import { render, staticRenderFns } from "./TabComponent.vue?vue&type=template&id=5cd7fd3c&scoped=true"
import script from "./TabComponent.vue?vue&type=script&lang=js"
export * from "./TabComponent.vue?vue&type=script&lang=js"
import style0 from "./TabComponent.vue?vue&type=style&index=0&id=5cd7fd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd7fd3c",
  null
  
)

export default component.exports